import moment from 'moment';

import 'moment/locale/bg';

import { LoggerService } from '../../lib/services/logger/Logger.service';

import config from '../../config';

import { RssItem } from './CapitalRSS.types';

moment.locale(config.portalLang);

export const parseRssFeed = async () => {
  const logger = LoggerService.getLogger();
  try {
    const response = await fetch(config.capital_rss.url, {
      headers: { 'X-CSRF': '1' },
    });
    const text = await response.text();

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, 'text/xml');
    const items = xmlDoc.getElementsByTagName('item');

    const rssFeedItems: RssItem[] = Array.from(items).map((item, id) => {
      const dateTime = new Date(item.getElementsByTagName('pubDate')[0].textContent || 0).getTime();
      return {
        id,
        headline: item.getElementsByTagName('title')[0].textContent || '',
        url: item.getElementsByTagName('link')[0].textContent || '',
        description: item.getElementsByTagName('description')[0].textContent?.split('<br />')[1] || '',
        dateTime,
        dateTimeText: moment(dateTime).fromNow(false),
        source: item.getElementsByTagName('category')[0]?.textContent?.split('<')[0].trim() || '',
        image: item.getElementsByTagName('description')[0].textContent?.split('src="')[1]?.split('"')[0] || '',
      };
    });

    return rssFeedItems;
  } catch (error) {
    logger.error('[Capital RSS] Error fetching RSS feed:', error);
    return [];
  }
};
